<template>
  <a
    class="page-link padded-link"
    data-sb-regression="sb-pagination-link"
    href="#"
    tabindex="-1"
    @click.prevent
  >
    <!--
      @slot slot to show the links to the pages
    -->
    <slot />
  </a>
</template>

<script>

export default {
  name: 'SbPaginationLink',
};
</script>

<style lang="scss">

</style>
